// extracted by mini-css-extract-plugin
module.exports = {"icon":"icon-events_icon__3IChX","title":"icon-events_title__3oXfg","menu":"icon-events_menu__2GbGe"};